<template>
  <div>
    <vxe-grid
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      size="small"
      resizable
      border
      row-key
      ref="XGrid"
      class="sortable-row-demo"
      :loading="loading"
      :scroll-y="{ enabled: false }"
    >
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  components: {},
  props: {
    code: {
      type: String,
    },
    incomeFreightCode: {
      type: String,
    },
  },
  data() {
    return {
      tableColumns: tableColumns(),
      tableData: [],
      loading:false,
    }
  },
  created() {},
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.code) return
      this.loading = true
      this.$api
        .finCustomerStatementDetaiListApi({
          custStatementCode: this.code,
          incomeFreightCode: this.incomeFreightCode,
        })
        .then((res) => {
          this.tableData = res.body.data
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
